import { render } from "./BatchRow.vue?vue&type=template&id=b2f9ca88&scoped=true"
import script from "./BatchRow.vue?vue&type=script&lang=js"
export * from "./BatchRow.vue?vue&type=script&lang=js"

import "./BatchRow.vue?vue&type=style&index=0&id=b2f9ca88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f9ca88"]])

export default __exports__